import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable()
export class FieldVisibilityService {
    constructor() { }

    fieldVisibility(question, form, isVisible) {
        var formControl = form.controls[question.key];
        if (formControl != undefined) {
            if (isVisible) {
                if (question.required) {
                    formControl.setValidators([Validators.required]);
                }
            } else {
                if (question.required) {
                    formControl.setValidators(null);
                }
            }
            question.visible = isVisible;
        }
    }

}
